import {
  useWatchTransactionReceipt,
  useWriteContract
} from "@buidlerlabs/hashgraph-react-wallets";
import AsyncToggle from "./reusable/AsyncToggle";
import { useState } from "react";
import { showNotification } from "@mantine/notifications";
import { IconX } from "@tabler/icons";

const ContractStateToggle = ({
  contractId,
  abi,
  functionName,
  enabled,
  onCompleted,
  label = "Contract state toggle"
}) => {
  const { writeContract } = useWriteContract();
  const { watch } = useWatchTransactionReceipt({
    abi
  });
  const [loading, setLoading] = useState(false);

  const handleToggleContract = async () => {
    return new Promise(async (resolve, reject) => {
      try {
        setLoading(true);

        const transactionIdOrHash = await writeContract({
          contractId,
          functionName,
          abi
        });

        await watch(transactionIdOrHash, {
          onSuccess(transaction) {
            onCompleted(transaction);
            resolve(transaction);

            return transaction;
          },
          onError(transaction, error) {
            const errorMessage =
              error.errorName === "Error"
                ? error.args.join(",")
                : error.errorName;

            showNotification({
              id: "contract-state-toggle",
              icon: <IconX />,
              autoClose: 4000,
              color: "red",
              title: "Failed to execute",
              message: errorMessage,
              loading: false
            });

            setLoading(false);
            reject(error);
            return transaction;
          }
        });
      } catch (e) {
        console.error(e);

        const errorMessage = JSON.stringify(e.message).includes("USER_REJECT")
          ? "User rejected action"
          : e.message;

        return showNotification({
          id: "contract-state-toggle",
          icon: <IconX />,
          autoClose: 4000,
          color: "red",
          title: "Failed to execute",
          message: errorMessage,
          loading: false
        });
      } finally {
        setLoading(false);
      }
    });
  };

  return (
    <AsyncToggle
      label={label}
      value={enabled}
      onChange={(e) => handleToggleContract(!e.target.checked)}
      loading={loading}
    />
  );
};

export default ContractStateToggle;
